export default __webpack_public_path__ + "static/media/filter-icon.8805dec7.svg";